module.exports = __webpack_public_path__ + "media/images/welcome/main_visual_logo-84c061b3326914596c4bbe550f8c2ef8.png";